module.exports = __webpack_public_path__ + "static/media/Intro.440625da.jpg";